
const projectData = [
  {
    id: 101,
    orgId: 1,
    title: "webevaluator.github.io",
    organization: "webevaluator",
    description: `The frontend website of the webevaluator tool built using React.js. The website is deployed at https://webevaluator.github.io/`,
    techstacks: ["javascript", "react", "html", "css"],
    github: "https://github.com/webevaluator/webevaluator.github.io",
    slack: "https://join.slack.com/t/webevaluator/shared_invite/zt-1i6rwnif9-hPh9fyg4ZZSpfI79d4hfbA",
  },
  {
    id: 102,
    orgId: 1,
    title: "nodebackend",
    organization: "webevaluator",
    description: `The Node.js backend server code which provides ADA complaince checks and pdf download option. The server is deployed online at https://webevaluator.onrender.com/api/status`,
    techstacks: ["javascript", "node.js", "express", "mongodb", "ejs", "puppeteer"],
    github: "https://github.com/webevaluator/nodebackend",
    slack: "https://join.slack.com/t/webevaluator/shared_invite/zt-1i6rwnif9-hPh9fyg4ZZSpfI79d4hfbA",
  },
  {
    id: 103,
    orgId: 1,
    title: "gobackend",
    organization: "webevaluator",
    description: `A Golang based web crawler which can serve upto 1000 requests/second/core. The server is deployed online at https://gowebevaluator.onrender.com/status`,
    techstacks: ["go"],
    github: "https://github.com/webevaluator/gobackend",
    slack: "https://join.slack.com/t/webevaluator/shared_invite/zt-1i6rwnif9-hPh9fyg4ZZSpfI79d4hfbA",
  },
  {
    id: 104,
    orgId: 1,
    title: "flaskbackend",
    organization: "webevaluator",
    description: `A flask based web server which provides information about missing security headers and SSL certificate. The server is deployed online at https://flask-backend-aman-codes.vercel.app/status`,
    techstacks: ["python", "flask"],
    github: "https://github.com/webevaluator/flaskbackend",
    slack: "https://join.slack.com/t/webevaluator/shared_invite/zt-1i6rwnif9-hPh9fyg4ZZSpfI79d4hfbA",
  },
  {
    id: 105,
    orgId: 1,
    title: "documentation",
    organization: "webevaluator",
    description: `The main documentation website of the organization built using Docusaurus 2, a modern static website generator. The website is deployed at https://webevaluator.github.io/documentation`,
    techstacks: ["markdown", "react", "javascript"],
    github: "https://github.com/webevaluator/documentation",
    slack: "https://join.slack.com/t/webevaluator/shared_invite/zt-1i6rwnif9-hPh9fyg4ZZSpfI79d4hfbA",
  },
  {
    id: 201,
    orgId: 2,
    title: "Pytorch Fanatics",
    organization: "MLpack404",
    description: `Pytorch_Fanatics is a Python library for ease of Computer Vision tasks. This contains a bunch of various tools which will help to create customized codes to train CV models. This includes the implementation of Dataloader Class, LR Finder, EarlyStopping, training, logger and a bunch of valuable tools.`,
    techstacks: ["python", "pytorch", "machine learning", "ml"],
    github: "https://github.com/MLpack404/pytorch_fanatics",
    slack: "https://join.slack.com/t/slack-lif3240/shared_invite/zt-1j3mtvccg-M54CV3v5y0y5wFIB_bgJvg",
  },
  {
    id: 301,
    orgId: 3,
    title: "Fundon App",
    organization: "Android Ants",
    description: `Fundon, a C2C (Customer to Customer) personal loan lending platform based on MVVM model which can be used to request loans from other users on the application and can also lend money to them.`,
    techstacks: ["android", "java", "xml"],
    github: "https://github.com/Android-Ants/Fundon-App",
    slack: "https://join.slack.com/t/android-ants-world/shared_invite/zt-1iyne8g29-AU4iSmZoNuOsCPLngn4LCw",
  },
  {
    id: 302,
    orgId: 3,
    title: "Fundon Server",
    organization: "Android Ants",
    description: `Application Server of Fundon build using Node Js.`,
    techstacks: ["javascript", "node.js"],
    github: "https://github.com/Android-Ants/FundonBackend",
    slack: "https://join.slack.com/t/android-ants-world/shared_invite/zt-1iyne8g29-AU4iSmZoNuOsCPLngn4LCw",
  },
  {
    id: 303,
    orgId: 3,
    title: "Jangarana App",
    organization: "Android Ants",
    description: `A Mobile application created to ease the process of making the census process of India with a higher efficiency.`,
    techstacks: ["android", "java", "xml"],
    github: "https://github.com/Android-Ants/Jangarana-App",
    slack: "https://join.slack.com/t/android-ants-world/shared_invite/zt-1iyne8g29-AU4iSmZoNuOsCPLngn4LCw",
  },
  {
    id: 304,
    orgId: 3,
    title: "Jangarana Server",
    organization: "Android Ants",
    description: `Application Server of Jangarna App build using Node Js.`,
    techstacks: ["javascript", "node.js"],
    github: "https://github.com/Android-Ants/JangaranaServer",
    slack: "https://join.slack.com/t/android-ants-world/shared_invite/zt-1iyne8g29-AU4iSmZoNuOsCPLngn4LCw",
  },
  {
    id: 305,
    orgId: 3,
    title: "Rev App",
    organization: "Android Ants",
    description: `An android application that fetches all your photos from Google Drive and display them in random fashion.`,
    techstacks: ["android", "java", "xml", "firebase"],
    github: "https://github.com/Android-Ants/Rev-App",
    slack: "https://join.slack.com/t/android-ants-world/shared_invite/zt-1iyne8g29-AU4iSmZoNuOsCPLngn4LCw",
  },
];

export default projectData;